<template>
  <v-card>
    <v-card-title class="justify-center">
      <span v-if="formType == 'addForm' " class="text-h5">{{ $t('Add') }}</span>
      <span v-if="formType == 'editForm' " class="text-h5">{{ $t('Edit') }}</span>
      <span v-if="formType == 'viewForm' " class="text-h5">{{ $t('Asset') }} <span v-if="formType == 'viewForm'"> - {{ getTranslation(asset.type) }}</span></span>
    </v-card-title>
    <v-card-text>
      <v-container>
        <v-row>
          <!--<v-col
            cols="12"
            sm="12"
          >
            <v-select
              v-if="formType == 'addForm'"
              :items="assetTypeList"
              :item-value="item=>item.translation.id"
              :item-text="item=>item.translation.name"
              :label="$t('Asset Type')"
              v-model="selectedAssetType"
              required
            >
              <template v-slot:item="{ item }">
                <div>{{ getTranslation(item.translation.name) }}</div>
              </template>              
            </v-select>
          </v-col>-->
          <!--<v-col
            cols="12"
            sm="12"
          >
            <v-select
              v-if="formType == 'addForm'"
              :items="assetTypeList"
              :item-value="item=>item.id"
              :item-text="item=>item.translation.name"
              :label="$t('Asset Type')"
              v-model="asset.asset_type_id"
              required
            >
              <template v-slot:item="{ item }">
                <div>{{ getTranslation(item.translation.name) }}</div>
              </template>              
            </v-select>
          </v-col>-->
        </v-row>

        <v-row>
          <v-col
            cols="6"
            sm="4"
          >
            <v-text-field 
              v-if="formType == 'addForm' || formType == 'editForm'"
              :label="$t('ID/Name')"
              required
              v-model="asset.asset_number"
            ></v-text-field>
            <div v-if="formType == 'viewForm' ">
              <p>{{ $t('ID/Name') }}</p>
              <p class="text-h4 text--primary">{{ asset.asset_number }}</p>
            </div>
          </v-col>
          <!--<v-col
            cols="6"
            sm="4"
          >
            <v-text-field
              v-if="formType == 'addForm' || formType == 'editForm'"
              :label="$t('Name')"
              required
              v-model="asset.name_en"
            ></v-text-field>
            <div v-if="formType == 'viewForm' ">
              <p>{{ $t('Name') }}</p>
              <p class="text-h4 text--primary">{{ getTranslation(asset.name) }}</p>
            </div>
          </v-col>-->
          <!--<v-col
            cols="6"
            sm="4"
          >
            <v-text-field
              v-if="formType == 'addForm' || formType == 'editForm'"
              :label="$t('Latitude')"
              required
              v-model="asset.latitude"
            ></v-text-field>
            <div v-if="formType == 'viewForm' ">
              <p>{{ $t('Latitude') }}</p>
              <p class="text-h4 text--primary">{{ asset.latitude }}</p>
            </div>
          </v-col>
          <v-col
            cols="6"
            sm="4"
          >
            <v-text-field
              v-if="formType == 'addForm' || formType == 'editForm'"
              :label="$t('Longitude')"
              required
              v-model="asset.longitude"
            ></v-text-field>
            <div v-if="formType == 'viewForm' ">
              <p>{{ $t('Longitude') }}</p>
              <p class="text-h4 text--primary">{{ asset.longitude }}</p>
            </div>
          </v-col>-->
          <!--<v-col
            cols="6"
            sm="4"
          >
            <v-select
                v-if="formType == 'addForm' || formType == 'editForm'"
                :items="yearList"
                item-value="id"
                item-text="name"
                :label="$t('Construction or Acquisition Year')"
                v-model="asset.construction_year"
                required
              ></v-select>
              <div v-if="formType == 'viewForm' ">
                <p>{{ $t('Construction or Acquisition Year') }}</p>
                <p class="text-h4 text--primary">{{asset.construction_year}}</p>
              </div>
          </v-col>-->
          <!--<v-col v-if="asset.type !== 'Equipment'"
            cols="6"
            sm="4"
          >
            <v-text-field
              v-if="formType == 'addForm' || formType == 'editForm'"
              :label="$t('Year of Construction')"
              required
              v-model="asset.construction_year"
            ></v-text-field>
            <div v-if="formType == 'viewForm' ">
              <p>{{ $t('Year of Construction') }}</p>
              <p class="text-h4 text--primary">{{ asset.construction_year }}</p>
            </div>
          </v-col>
          <v-col v-if="asset.type == 'Equipment'"
            cols="6"
            sm="4"
          >
            <v-text-field
              v-if="formType == 'addForm' || formType == 'editForm'"
              :label="$t('Year of Acquisition')"
              required
              v-model="asset.acquisition_year"
            ></v-text-field>
            <div v-if="formType == 'viewForm' ">
              <p>{{ $t('Year of Acquisition') }}</p>
              <p class="text-h4 text--primary">{{ asset.acquisition_year }}</p>
            </div>
          </v-col>-->
        </v-row>

          <!--<v-row>
            <v-col
              cols="12"
              sm="4"
            >
              <v-autocomplete
                v-if="formType == 'addForm' || formType == 'editForm'"
                :items="provinceList"
                :item-value="item=>item.translation.id"
                :item-text="item=>item.translation.name"
                :label="$t('Province')"
                v-model="asset.province"
                multiple
              >
                <template v-slot:item="{ item }">
                  <div>{{ getTranslation(item.translation.name) }}</div>
                </template>
              </v-autocomplete>
              <div v-if="formType == 'viewForm'">
                <p>{{ $t('Province') }}</p>
                <p class="text-h4 text--primary">{{ getTranslation(asset.province) }}</p>
              </div>
            </v-col>
            <v-col
              cols="12"
              sm="4"
            >
              <v-autocomplete
                v-if="formType == 'addForm' || formType == 'editForm'"
                :items="districtList"
                :item-value="item=>item.translation.id"
                :item-text="item=>item.translation.name"
                :label="$t('District')"
                v-model="asset.district"
                multiple
              >
                <template v-slot:item="{ item }">
                  <div>{{ getTranslation(item.translation.name) }}</div>
                </template>
              </v-autocomplete>
              <div v-if="formType == 'viewForm' ">
                <p>{{ $t('District') }}</p>
                <p class="text-h4 text--primary">{{ getTranslation(asset.district) }}</p>
              </div>
            </v-col>
            <v-col
              cols="12"
              sm="4"
            >
              <v-autocomplete
                v-if="formType == 'addForm' || formType == 'editForm'"
                :items="villageList"
                :item-value="item=>item.translation.id"
                :item-text="item=>item.translation.name"
                :label="$t('Village')"
                v-model="asset.village"
                multiple
              >
                <template v-slot:item="{ item }">
                  <div>{{ getTranslation(item.translation.name) }}</div>
                </template>
              </v-autocomplete>
              <div v-if="formType == 'viewForm' ">
                <p>{{ $t('Village') }}</p>
                <p class="text-h4 text--primary">{{ getTranslation(asset.village) }}</p>
              </div>
            </v-col>

          </v-row>-->
      
        <!--------------------------------- Road Part --------------->
        <v-row v-if="asset.type == 'Road' ">
          <v-col
            cols="6"
            sm="3"
          >
            <v-text-field
              v-if="formType == 'addForm' || formType == 'editForm'"
              :label="$t('KM Begin')"
              type="number"
              required
              v-model="asset.km_begin"
            ></v-text-field>
            <div v-if="formType == 'viewForm' ">
              <p>{{ $t('KM Begin') }}</p>
              <p class="text-h4 text--primary">{{ asset.km_begin }}</p>
            </div>
          </v-col>
          <v-col
            cols="6"
            sm="3"
          >
            <v-text-field
              v-if="formType == 'addForm' || formType == 'editForm'"
              :label="$t('KM End')"
              type="number"
              required
              v-model="asset.km_end"
            ></v-text-field>
            <div v-if="formType == 'viewForm' ">
              <p>{{ $t('KM End') }}</p>
              <p class="text-h4 text--primary">{{ asset.km_end }}</p>
            </div>
          </v-col>
          <v-col
            cols="6"
            sm="3"
          >
            <v-text-field
              v-if="formType == 'addForm' || formType == 'editForm'"
              :label="$t('Width')"
              type="number"
              required
              v-model="asset.width"
            ></v-text-field>
            <div v-if="formType == 'viewForm' ">
              <p>{{ $t('Width') }}</p>
              <p class="text-h4 text--primary">{{ asset.width }}</p>
            </div>
          </v-col>
          <v-col
            cols="6"
            sm="3"
          >
            <v-text-field
              v-if="formType == 'addForm' || formType == 'editForm'"
              :label="$t('Length')"
              type="number"
              required
              v-model="asset.length"
            ></v-text-field>
            <div v-if="formType == 'viewForm' ">
              <p>{{ $t('Length') }}</p>
              <p class="text-h4 text--primary">{{ asset.length }}</p>
            </div>
          </v-col>
          <v-col
            cols="6" 
            sm="4"
          >
            <v-select
              v-if="formType == 'addForm' || formType == 'editForm'"
              :items="roadClassList"
              :item-value="item=>item.id"
              :item-text="item=>item.translation.name"
              :label="$t('Class')"
              v-model="asset.road_class_id"
              required
            >
              <template v-slot:item="{ item }">
                <div>{{ getTranslation(item.translation.name) }}</div>
              </template>
            </v-select>
            <div v-if="formType == 'viewForm' ">
              <p>{{ $t('Class') }}</p>
              <p class="text-h4 text--primary">{{ getTranslation(asset.translation.name) }}</p>
            </div> 
          </v-col>
          <v-col
            cols="6" 
            sm="4"
          >
            <v-select 
              v-if="formType == 'addForm' || formType == 'editForm'"
              :items="roadTypeList"
              :item-value="item=>item.id"
              :item-text="item=>item.translation.name"
              :label="$t('Category')"
              v-model="asset.road_type_id"
              required
            >
              <template v-slot:item="{ item }">
                <div>{{ getTranslation(item.translation.name) }}</div>
              </template>
            </v-select>
            <div v-if="formType == 'viewForm' ">
              <p>{{ $t('Category') }}</p>
              <p class="text-h4 text--primary">{{ getTranslation(asset.translation.name) }}</p>
            </div> 
          </v-col>
          <v-col
            cols="6" 
            sm="4"
          >
            <v-select 
              v-if="formType == 'addForm' || formType == 'editForm'"
              :items="roadSurfaceList"
              :item-value="item=>item.id"
              :item-text="item=>item.translation.name"
              :label="$t('Pavement Surface')"
              v-model="asset.road_surface_id"
              required
            >
              <template v-slot:item="{ item }">
                <div>{{ getTranslation(item.translation.name) }}</div>
              </template>
            </v-select>
            <div v-if="formType == 'viewForm' ">
              <p>{{ $t('Pavement Surface') }}</p>
              <p class="text-h4 text--primary">{{ getTranslation(asset.translation.name) }}</p>
            </div> 
          </v-col>
        </v-row>

        <!--------------------------------- Bridge Part --------------->
        <v-row v-if="asset.type == 'Bridge' ">
          <!--<v-col
            cols="6"
            sm="4"
          >
            <v-text-field
              v-if="formType == 'addForm' || formType == 'editForm'"
              :label="$t('Latitude')"
              required
              v-model="asset.latitude"
            ></v-text-field>
            <div v-if="formType == 'viewForm' ">
              <p>{{ $t('Latitude') }}</p>
              <p class="text-h4 text--primary">{{ asset.latitude }}</p>
            </div>
          </v-col>
          <v-col
            cols="6"
            sm="4"
          >
            <v-text-field
              v-if="formType == 'addForm' || formType == 'editForm'"
              :label="$t('Longitude')"
              required
              v-model="asset.longitude"
            ></v-text-field>
            <div v-if="formType == 'viewForm' ">
              <p>{{ $t('Longitude') }}</p>
              <p class="text-h4 text--primary">{{ asset.longitude }}</p>
            </div>
          </v-col>-->
          <v-col
            cols="6"
            sm="4"
          >
            <v-text-field
              v-if="formType == 'addForm' || formType == 'editForm'"
              :label="$t('GPS Location')"
              required
              v-model="asset.gps_location"
            ></v-text-field>
            <div v-if="formType == 'viewForm' ">
              <p>{{ $t('GPS Location') }}</p>
              <p class="text-h4 text--primary">{{ asset.gps_location }}</p>
            </div>
          </v-col>
          <v-col
            cols="6"
            sm="4"
          >
            <v-select
              v-if="formType == 'addForm' || formType == 'editForm'"
              :label="$t('River')"
              :items="riverList"
              :item-value="item=>item.id"
              :item-text="item=>item.translation.name"
              required
              v-model="asset.river_id"
            ></v-select>
            <div v-if="formType == 'viewForm' ">
              <p>{{ $t('River') }}</p>
              <p class="text-h4 text--primary">{{ getTranslation(asset.river) }}</p>
            </div>
          </v-col>
          <v-col
            cols="6"
            sm="4"
          >
            <v-text-field
              v-if="formType == 'addForm' || formType == 'editForm'"
              :label="$t('Length (Km)')"
              type="number"
              required
              v-model="asset.length"
            ></v-text-field>
            <div v-if="formType == 'viewForm' ">
              <p>{{ $t('Length (Km)') }}</p>
              <p class="text-h4 text--primary">{{ asset.length }}</p>
            </div>
          </v-col>
          <v-col
            cols="6"
            sm="4"
          >
            <v-text-field
              v-if="formType == 'addForm' || formType == 'editForm'"
              :label="$t('Surface (Km2)')"
              type="number"
              required
              v-model="asset.surface"
            ></v-text-field>
            <div v-if="formType == 'viewForm' ">
              <p>{{ $t('Surface (Km2)') }}</p>
              <p class="text-h4 text--primary">{{ asset.surface }}</p>
            </div>
          </v-col>
          <!--<v-col
            cols="6"
            sm="4"
          >
            <v-text-field
              v-if="formType == 'addForm' || formType == 'editForm'"
              :label="$t('Year of Construction')"
              required
              v-model="asset.construction_year"
            ></v-text-field>
            <div v-if="formType == 'viewForm' ">
              <p>{{ $t('Year of Construction') }}</p>
              <p class="text-h4 text--primary">{{ asset.construction_year }}</p>
            </div>
          </v-col>-->
          <v-col
            cols="6"
            sm="4"
          >
          <v-select 
              v-if="formType == 'addForm' || formType == 'editForm'"
              :items="bridgeCategoryList"
              :item-value="item=>item.id"
              :item-text="item=>item.translation.name"
              :label="$t('Bridge Type')"
              v-model="asset.bridge_type_id"
              required
            >
              <template v-slot:item="{ item }">
                <div>{{ getTranslation(item.translation.name) }}</div>
              </template>
            </v-select>
            <div v-if="formType == 'viewForm' ">
              <p>{{ $t('Bridge Type') }}</p>
              <p class="text-h4 text--primary">{{ getTranslation(asset.bridge_type) }}</p>
            </div> 
          </v-col>
        </v-row>



        <!--------------------------------- Irrigation Part --------------->
        <v-row v-if="asset.type == 'Irrigation'">
          <v-col
            cols="6"
            sm="4"
          >
            <v-text-field
              v-if="formType == 'addForm' || formType == 'editForm'"
              :label="$t('GPS Location')"
              required
              v-model="asset.gps_location"
            ></v-text-field>
            <div v-if="formType == 'viewForm' ">
              <p>{{ $t('GPS Location') }}</p>
              <p class="text-h4 text--primary">{{ asset.gps_location }}</p>
            </div>
          </v-col>
          <v-col
            cols="6"
            sm="4"
          >
            <v-text-field
              v-if="formType == 'addForm' || formType == 'editForm'"
              :label="$t('Length')"
              type="number"
              required
              v-model="asset.length"
            ></v-text-field>
            <div v-if="formType == 'viewForm' ">
              <p>{{ $t('Length') }}</p>
              <p class="text-h4 text--primary">{{ asset.length }}</p>
            </div>
          </v-col>
          <v-col
            cols="6"
            sm="4"
          >
            <v-select
              v-if="formType == 'addForm' || formType == 'editForm'"
              :items="irrigationCategoryList"
              :item-value="item=>item.id"
              :item-text="item=>item.translation.name"
              :label="$t('Size')"
              v-model="asset.irrigation_category_id"
              required
            >
              <template v-slot:item="{ item }">
                <div>{{ getTranslation(item.translation.name) }}</div>
              </template>
            </v-select>
            <div v-if="formType == 'viewForm' ">
              <p>{{ $t('Size') }}</p>
              <p class="text-h4 text--primary">{{ getTranslation(asset.irrigation_category) }}</p>
            </div>
          </v-col>
          <v-col
            cols="6" 
            sm="4"
          >
            <v-select
              v-if="formType == 'addForm' || formType == 'editForm'"
              :items="irrigationTypeList"
              :item-value="item=>item.id"
              :item-text="item=>item.translation.name"
              :label="$t('Irrigation Type')"
              v-model="asset.irrigation_type_id"
              required
            >
              <template v-slot:item="{ item }">
                <div>{{ getTranslation(item.translation.name) }}</div>
              </template>
            </v-select>
            <div v-if="formType == 'viewForm' ">
              <p>{{ $t('Irrigation Type') }}</p>
              <p class="text-h4 text--primary">{{ getTranslation(asset.irrigation_type) }}</p>
            </div> 
          </v-col>
          <!--<v-col
            cols="6" 
            sm="6"
          >
            <v-select
              v-if="formType == 'addForm' || formType == 'editForm'"
              :items="irrigationConstructionMethodList"
              item-value="id"
              item-text="name_en"
              :label="$t('Construction Method')"
              v-model="asset.construction_method"
              required
            >
              <template v-slot:item="{ item }">
                <div>{{ getTranslation(item) }}</div>
              </template>
            </v-select>
            <div v-if="formType == 'viewForm' ">
              <p>{{ $t('Construction Method') }}</p>
              <p class="text-h4 text--primary">{{ getTranslation(asset.construction_method) }}</p>
            </div> 
          </v-col>-->
        </v-row>


        <!--------------------------------- Hospital/School/Public Bulding Part --------------->
        <v-row v-if="asset.type == 'Hospital' || asset.type == 'School'  || asset.type == 'Public Building'">
          <!--<v-col
            cols="6"
            sm="4"
          >
            <v-text-field
              v-if="formType == 'addForm' || formType == 'editForm'"
              :label="$t('Latitude')"
              required
              v-model="asset.latitude"
            ></v-text-field>
            <div v-if="formType == 'viewForm' ">
              <p>{{ $t('Latitude') }}</p>
              <p class="text-h4 text--primary">{{ asset.latitude }}</p>
            </div>
          </v-col>
          <v-col
            cols="6"
            sm="4"
          >
            <v-text-field
              v-if="formType == 'addForm' || formType == 'editForm'"
              :label="$t('Longitude')"
              required
              v-model="asset.longitude"
            ></v-text-field>
            <div v-if="formType == 'viewForm' ">
              <p>{{ $t('Longitude') }}</p>
              <p class="text-h4 text--primary">{{ asset.longitude }}</p>
            </div>
          </v-col>-->
          <v-col
            cols="6"
            sm="4"
          >
            <v-text-field
              v-if="formType == 'addForm' || formType == 'editForm'"
              :label="$t('GPS Location')"
              required
              v-model="asset.gps_location"
            ></v-text-field>
            <div v-if="formType == 'viewForm' ">
              <p>{{ $t('GPS Location') }}</p>
              <p class="text-h4 text--primary">{{ asset.gps_location }}</p>
            </div>
          </v-col>
          <v-col v-if="asset.type == 'Public Building'"
            cols="6" 
            sm="3"
          >
            <v-select
              v-if="formType == 'addForm' || formType == 'editForm'"
              :items="buildingMinistryList"
              :item-value="item=>item.id"
              :item-text="item=>item.translation.name"
              :label="$t('Ministry')"
              v-model="asset.building_ministry_id"
              required
            >
              <template v-slot:item="{ item }">
                <div>{{ getTranslation(item.translation.name) }}</div>
              </template>
            </v-select>
            <div v-if="formType == 'viewForm' ">
              <p>{{ $t('Ministry') }}</p>
              <p class="text-h4 text--primary">{{ getTranslation(asset.ministry) }}</p>
            </div> 
          </v-col>
          <v-col
            cols="6" 
            sm="4"
          >
            <v-select
              v-if="formType == 'addForm' || formType == 'editForm'"
              :items="buildingTypeList"
              :item-value="item=>item.id"
              :item-text="item=>item.translation.name"
              :label="$t('Building Type')"
              v-model="asset.building_type_id"
              required
            >
              <template v-slot:item="{ item }">
                <div>{{ getTranslation(item.translation.name) }}</div>
              </template>
            </v-select>
            <div v-if="formType == 'viewForm' ">
              <p>{{ $t('Building Type') }}</p>
              <p class="text-h4 text--primary">{{ getTranslation(asset.building_type) }}</p>
            </div> 
          </v-col>
        </v-row>

        <!--------------------------------- Equipement Part --------------->
        <v-row v-if="asset.type == 'Equipment'">
          <!--<v-col
            cols="6"
            sm="4"
          >
            <v-text-field
              v-if="formType == 'addForm' || formType == 'editForm'"
              :label="$t('Latitude')"
              required
              v-model="asset.latitude"
            ></v-text-field>
            <div v-if="formType == 'viewForm' ">
              <p>{{ $t('Latitude') }}</p>
              <p class="text-h4 text--primary">{{ asset.latitude }}</p>
            </div>
          </v-col>
          <v-col
            cols="6"
            sm="4"
          >
            <v-text-field
              v-if="formType == 'addForm' || formType == 'editForm'"
              :label="$t('Longitude')"
              required
              v-model="asset.longitude"
            ></v-text-field>
            <div v-if="formType == 'viewForm' ">
              <p>{{ $t('Longitude') }}</p>
              <p class="text-h4 text--primary">{{ asset.longitude }}</p>
            </div>
          </v-col>-->
          <v-col
            cols="6"
            sm="4"
          >
            <v-text-field
              v-if="formType == 'addForm' || formType == 'editForm'"
              :label="$t('GPS Location')"
              required
              v-model="asset.gps_location"
            ></v-text-field>
            <div v-if="formType == 'viewForm' ">
              <p>{{ $t('GPS Location') }}</p>
              <p class="text-h4 text--primary">{{ asset.gps_location }}</p>
            </div>
          </v-col>
          <v-col
            cols="6" 
            sm="4"
          >
            <v-select
              v-if="formType == 'addForm' || formType == 'editForm'"
              :items="equipmentCategoryList"
              :item-value="item=>item.id"
              :item-text="item=>item.translation.name"
              :label="$t('Category')"
              v-model="asset.equipment_category_id"
              required
            >
              <template v-slot:item="{ item }">
                <div>{{ getTranslation(item.translation.name) }}</div>
              </template>
            </v-select>
            <div v-if="formType == 'viewForm' ">
              <p>{{ $t('Category') }}</p>
              <p class="text-h4 text--primary">{{ getTranslation(asset.category) }}</p>
            </div> 
          </v-col>
          <!--<v-col
            cols="6" 
            sm="3"
          >
            <v-select
              v-if="formType == 'addForm' || formType == 'editForm'"
              :items="buildingCategoryList"
              item-value="id"
              item-text="name_en"
              label="Category"
              v-model="asset.category"
              required
            ></v-select>
            <div v-if="formType == 'viewForm' ">
              <p>Category</p>
              <p class="text-h4 text--primary">{{ asset.category }}</p>
            </div> 
          </v-col>-->
        </v-row>
        
        <!--<v-row v-if="formType == 'addForm'">
          <v-btn
            color="grey darken-1"
            text
            style="border:1px solid grey"
            v-on:click="close()"
          >
            {{ $t('Insert Shapefile') }}
          </v-btn>
        </v-row>-->
      </v-container>
    </v-card-text>
    <v-card-actions v-if="formType == 'addForm' || formType == 'editForm'">
      <v-spacer></v-spacer>
      <v-btn
        color="grey darken-1"
        text
        v-on:click="close()"
      >
        {{ $t('Close') }}
      </v-btn>
      <v-btn
        color="white darken-1"
        style="background-color:#31c0be;"
        text
        v-on:click="save(asset)"
      >
        {{ $t('Save') }}
      </v-btn>
    </v-card-actions>
    <v-card-actions v-if="formType == 'viewForm' ">
      <v-spacer></v-spacer>
      <v-btn
        color="grey darken-1"
        text
        v-on:click="close()"
      >
        {{ $t('Close') }}
      </v-btn>
      <v-btn class="small" color="success" v-bind="attrs" v-on="on" v-on:click="update(asset)">
        <v-icon>mdi-update</v-icon>
      </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
  export default {
    name: 'AssetForm',
    props: {
      assetProps: {
        type: Object
      },
      assetType: {
        //type: String
        type: Number
      },
      formType: {
        type: String
      }
    },
    data: () => ({
      asset: {}
      //selectedAssetType: '',
      //workTypeList: ['Reconstruction','Emergency Repair'],
      //disasterList: ['Flood 2018','Tropical Cyclone Dianmu'],
      //assetTypeList: ['Road','Bridge','Irrigation','Hospital','School','Public Building','Equipment'],
      //irrigationCategoryList: ['Large Scheme', 'Medium Scheme', 'Small Scheme'],
      //roadClassList: ['National','Provincial'],
      //bridgeCategoryList: ['Concrete','Bailey','Arch','Suspension','Wooden'],
      //irrigationTypeList: ['Weir','Pump','Reservoir'],
      //irrigationConstructionMethodList: ['Ground','Ciment'],
      //buildingCategoryList: ['Hospital','School'],
      //roadSurfaceList: ['Gravel','Earth','Paved','Terrain'],
      //roadTypeList: ['Urban','Semi-Urban'],
      //buildingTypeList: ['Ciment','Wooden'],
      //equipmentCategoryList: ['Road','Bridge','Irrigation','Hospital','School'],
      //buildingMinistryList: ['MPI - DPI Vientiane Province','MPI - DPI Bokeo Province']
    }),
    computed: {
        riverList() {
          return this.$store.state.referentials.riverList;
        },
        irrigationCategoryList() {
          return this.$store.state.referentials.irrigationCategoryList;
        },
        roadClassList() {
          return this.$store.state.referentials.roadClassList;
        },
        bridgeCategoryList() {
          return this.$store.state.referentials.bridgeCategoryList;
        },
        irrigationTypeList() {
          return this.$store.state.referentials.irrigationTypeList;
        },
        roadSurfaceList() {
          return this.$store.state.referentials.roadSurfaceList;
        },
        roadTypeList() {
          return this.$store.state.referentials.roadTypeList;
        },
        buildingTypeList() {
          return this.$store.state.referentials.buildingTypeList;
        },
        equipmentCategoryList() {
          return this.$store.state.referentials.equipmentCategoryList;
        },
        buildingMinistryList() {
          return this.$store.state.referentials.buildingMinistryList;
        },
        yearList() {
          return this.$store.state.referentials.yearList;
        },
        assetTypeList() {
          return this.$store.state.referentials.assetTypeList;
        },
        provinceList() {
          return this.$store.state.referentials.provinceList;
        },
        districtList() {
          return this.$store.state.referentials.districtList;
        },
        villageList() {
          return this.$store.state.referentials.villageList;
        },  
    },
    watch: { 
      asset: function(){
        this.asset.asset_type_id = this._props.assetType;
      }
    },
    mounted: function(){
      this.asset = this._props.assetProps;
      this.$store.dispatch('referentials/getProvinceList');
      this.$store.dispatch('referentials/getDistrictList');
      this.$store.dispatch('referentials/getVillageList');
      this.$store.dispatch('referentials/getIrrigationCategoryList');
      this.$store.dispatch('referentials/getRoadClassList');
      this.$store.dispatch('referentials/getBridgeCategoryList');
      this.$store.dispatch('referentials/getIrrigationTypeList');
      this.$store.dispatch('referentials/getRoadSurfaceList');
      this.$store.dispatch('referentials/getRoadTypeList');
      this.$store.dispatch('referentials/getYearList');
      this.$store.dispatch('referentials/getBuildingTypeList');
      this.$store.dispatch('referentials/getEquipmentCategoryList');
      this.$store.dispatch('referentials/getBuildingMinistryList');
      //this.$store.dispatch('referentials/getAssetTypeList');
      this.$store.dispatch('referentials/getRiverList');
      this.asset.asset_type_id = this._props.assetType;
    },
    methods: {
      getTranslation(val) {
        return this.$t(val);
      },
      close: function(){
        //this.selectedAssetType = '';
        this.$emit('update:dialog', false)
      },
      save: function(asset){
        //if(this.formType == 'addForm' && this.selectedAssetType === "Road"){ 
        if(this.formType == 'addForm' && this.asset.asset_type_id === 1){ //Road
          this.$emit('update:dialog', false);
          this.$store.dispatch('assets/addAffectedRoad',this.asset);
        }
        if(this.formType == 'addForm' && this.asset.asset_type_id === 2){ //Bridge
          this.$emit('update:dialog', false);
          this.$store.dispatch('assets/addAffectedBridge',this.asset);
        }
        if(this.formType == 'addForm' && this.asset.asset_type_id === 3){ //School
          this.$emit('update:dialog', false);
          this.$store.dispatch('assets/addAffectedSchool',this.asset);
        }
        if(this.formType == 'addForm' && this.asset.asset_type_id === 4){ //Hospital
          this.$emit('update:dialog', false);
          this.$store.dispatch('assets/addAffectedHospital',this.asset);
        }
        if(this.formType == 'addForm' && this.asset.asset_type_id === 5){ //Public Building
          this.$emit('update:dialog', false);
          this.$store.dispatch('assets/addAffectedPublicBuilding',this.asset);
        }
        if(this.formType == 'addForm' && this.asset.asset_type_id === 6){ //Irrigation
          this.$emit('update:dialog', false);
          this.$store.dispatch('assets/addAffectedIrrigation',this.asset);
        }
        if(this.formType == 'addForm' && this.asset.asset_type_id === 7){ //Equipment
          this.$emit('update:dialog', false);
          this.$store.dispatch('assets/addAffectedEquipment',this.asset);
        }
        this.asset = {};
        //this.formType = 'editForm';
        //this.asset = asset;
        //this.$emit('update:dialog', false)
      }
      /*save: function(){
        if(this.formType == 'addForm'){
          this.$store.dispatch('disasters/addDisaster',this.disaster);
        }
        if(this.formType == 'editForm'){
          this.$store.dispatch('disasters/updateDisaster',this.disaster);
        }
        console.log(this.disaster);
        this.$emit('update:dialog', false)
      }*/
    }
  }
</script>
